import L from 'leaflet';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

export const OSM_TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

export const toCoord = (v) => {
  const n = typeof v === 'string' ? parseFloat(v) : v;
  return Number.isFinite(n) && n !== 0 ? n : null;
};

export const hasCoords = (item) => toCoord(item?.latitude) !== null && toCoord(item?.longitude) !== null;

// Cluster bubble showing the number of items at the same spot, colored by content
export const createClusterIcon = (cluster) => {
  const children = cluster.getAllChildMarkers();
  const count = children.length;
  const types = new Set(children.map(m => m.options.markerType));
  let bg = '#1E3A8A';
  if (types.size === 1) {
    const only = [...types][0];
    bg = only === 'contractor' ? '#F59E0B' : only === 'company' ? '#10B981' : only === 'both' ? 'linear-gradient(90deg,#F59E0B 50%,#10B981 50%)' : '#1E3A8A';
  } else {
    bg = 'linear-gradient(135deg,#1E3A8A 0%,#1E3A8A 50%,#F59E0B 50%,#F59E0B 100%)';
  }
  const size = count < 10 ? 36 : count < 100 ? 42 : 48;
  return new L.DivIcon({
    className: 'custom-cluster',
    html: `<div style="background:${bg};width:${size}px;height:${size}px;border-radius:50%;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.35);display:flex;align-items:center;justify-content:center;color:white;font-weight:700;font-size:${count < 100 ? 14 : 12}px;font-family:inherit;">${count}</div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
};

export const CLUSTER_OPTIONS = {
  iconCreateFunction: createClusterIcon,
  maxClusterRadius: 40,
  spiderfyOnMaxZoom: true,
  showCoverageOnHover: false,
  zoomToBoundsOnClick: true,
  spiderfyDistanceMultiplier: 1.5,
};
